import Vue from 'vue'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
import BootstrapVue from 'bootstrap-vue'

import App from './App.vue'
import store from './store'
import '@/styles/main.scss'

Vue.config.productionTip = false

Vue.use(BootstrapVue)
//Vue.use(require('vue-scrollto'))

// Require in a base component context
const requireComponent = require.context(
  '@/components', false, /base-[\w-]+\.vue$/
)
requireComponent.keys().forEach(fileName => {
  // Get component config
  const componentConfig = requireComponent(fileName)

  // Get PascalCase name of component
  const componentName = upperFirst(
    camelCase(fileName.replace(/^\.\//, '').replace(/\.\w+$/, ''))
  )

  // Register component globally
  Vue.component(componentName, componentConfig.default || componentConfig)
})

/*
Vue.mixin({
  data: function() {
    return {
      _: require('lodash'),
    }
  }
})
*/

new Vue({
  render: h => h(App),
  store,
}).$mount('#app')
